import React, {  useEffect} from 'react';
//import Button from '@mui/material/Button';
 
import { Button } from '@mui/material';
import { Link,useNavigate } from "react-router-dom";
import AxiosFetchData from './AxiosFetchData';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
  
import MainPrint from './MainPrint.js';
import {Modal, Typography} from '@mui/material';
import Box from '@mui/material/Box';
import Helper from './Helper.js';
export default function PrintPreview({children,open,setopen,id=null}) {
    const [content, setContent] = React.useState({__html: ''});
    const Navigate = useNavigate();
    var result = "";
    var nbsp = "&nbsp;"
    var totalInvoice = 0;

  useEffect(() => {
     const urlParams =  window.location.pathname.split('/')[1];
    
     if(urlParams == 'EditInvoice'){
        handleEditPrintInvoice(id)
        return;
      }

      handleAddPrintInvoice(id)
     
  }, [open]);
  
  
async function handleEditPrintInvoice(id){
    try{
      var response = await AxiosFetchData.get(`GetInvoice/${id}`).refreshToken(Navigate,"invoice");
    
      if(response)
      {
          // var data = {
          //   data : JSON.parse(children)
          // }
         
          // result ='';
          // GetTreeView(data.data.treeview);
          
          // var mainPrint = new MainPrint(id)
          // setContent({__html: mainPrint.printInvoice(`${result}`, response.data.customer, data.data.invoice, data.data.retensi)});
          Print(id, response.data.customer)
      }
    }catch(error){
          //setmessage(error.message);
    }
      
  }
 

  async function handleAddPrintInvoice(id){
    try{
      var response = await AxiosFetchData.get(`GetCustomer/${id}`).refreshToken(Navigate,"invoice");
    
      if(response)
      {
        //console.log(response)
          // var data = {
          //   data : JSON.parse(children)
          // }
         
          // result ='';
          // GetTreeView(data.data.treeview);
          
          // var mainPrint = new MainPrint(id)
          // setContent({__html: mainPrint.printInvoice(`${result}`, response, data.data.invoice, data.data.retensi)});
          Print(id, response.data)
      }
    }catch(error){
          //setmessage(error.message);
    }
      
  }

  function Print(id, cust){
    var data = {
      data : JSON.parse(children)
    }
   console.log(data)
    result ='';
    GetTreeView(data.data.treeview);
     
    var mainPrint = new MainPrint(id)
    setContent({__html: mainPrint.printInvoiceV2(`${result}`, cust, data.data.invoice, data.data.retensi)});
  }
  
function GetTreeView(data)
{
 // console.log(data)
    // console.log(data)
   // data = JSON.parse(data);
   
    var no =1;
    for(let i = 0; i <  data.length; i++){
        
            result +=`<tr style="background-color: ${i % 2 === 0 ? '#f1f1f1' : '#ffffff'}; font-family:arial; font-size:11px;" key=${i}>
                        <td>&nbsp;</td>`

                        if(data[i].part_no){
                            result +=  `<td>${no++}.</td>`
                        }else{
                            result += `<td>&nbsp;</td>`
                        }
                       
              result += `<td>${data[i].part_no ?  data[i].part_no : ""}</td>
                        <td>${data[i].descriptions ? data[i].descriptions.replace(/(?:\r\n|\r|\n)/g, '<br>') : ''}</td>
                        <td>${data[i].newqty ? data[i].newqty : ""}</td>
                        <td>${data[i].unit_name ? data[i].unit_name : ""}</td>
                        <td>${data[i].price ?  Helper.formatAsCurrency(data[i].price) : ""}</td>
                        
                        <td>${(data[i].newqty && data[i].price) ?  Helper.formatAsCurrency(data[i].newqty * data[i].price) : ""}</td>
                </tr>`
            if(data[i].newqty && data[i].price){
                totalInvoice += data[i].newqty * data[i].price
            }

            if(data[i].subChild){
              recursive(data[i].subChild);
            }
            
         
            nbsp ="";
       
    }
  
}

//var nbsp = "&nbsp;"
function recursive(data)
{
   
    if( data.length > 0){
        
        nbsp += "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"
        for(let i = 0; i < data.length; i++){
        
                result +=`<tr style="background-color: ${i % 2 === 0 ? '#f1f1f1' : '#ffffff'}; font-family:arial; font-size:11px;" key=${i}>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>${nbsp}${data[i].part_no ? data[i].part_no : ""}</td>
                            <td>${nbsp}- ${data[i].descriptions}</td>
                            <td>${data[i].newqty ? data[i].newqty : ""}</td>
                            <td>${data[i].unit_name ?  data[i].unit_name : ""}</td>
                            <td>${data[i].price ? Helper.formatAsCurrency(data[i].price) : "-"}</td>
                            
                            <td>${(data[i].newqty && data[i].price) ? Helper.formatAsCurrency((data[i].newqty * data[i].price)) : ""}</td>
                        </tr>`

                        if(data[i].newqty && data[i].price){
                            totalInvoice += data[i].newqty * data[i].price
                        }
                   
                        if(data[i].subChild){
                          recursive(data[i].subChild);
                        }
                       
        

        }
        
    }
   
}

  return (
     
      <Modal
        open={open}
        onClose={() => setopen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        id="satu"
      >
        <Box className='modals' >
        <div id="testId" className="test"> 
          <Typography id="modal-modal-title" variant="h6" component="h2">
            <div id="modalcontent" dangerouslySetInnerHTML={content}>
              
            </div>
           
          </Typography>
          <Typography id="modal-modal-description">
          
            <button
              onClick={() => setopen(false)}
              className='close-button'
            >
              Close
            </button>
          </Typography>
          </div>
        </Box>
        </Modal>
     
       
    
  );
}